import {
  type AccountSummaryBadgeVariant,
  type AccountSummaryPaymentMethodItem,
  type AccountSummarySavedCardItem,
  type ProfilePaymentMethodsSummary,
} from '@assets/mockdata/PatientTray/mockAccountSummary'
import type { SavedCard } from '@dataTypes/payment.types'
import type { SavedCardDisplay } from '@services/api/billing/payment-method.api'

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isValidPaymentMethodId(id: string): boolean {
  return UUID_PATTERN.test(id)
}

export function paymentMethodBadgeVariant(
  isDefault: boolean,
): AccountSummaryBadgeVariant {
  return isDefault ? 'default' : 'supplementary'
}

const CARD_BRAND_LABELS: Record<SavedCard['brand'], string> = {
  visa: 'Visa',
  mastercard: 'MasterCard',
  amex: 'Amex',
  diners: 'Diners',
  discover: 'Discover',
  jcb: 'JCB',
  unionpay: 'UnionPay',
  unknown: 'Card',
}

export function formatCardBrandLabel(
  brand: SavedCard['brand'] | string,
): string {
  if (brand in CARD_BRAND_LABELS) {
    return CARD_BRAND_LABELS[brand as SavedCard['brand']]
  }
  return CARD_BRAND_LABELS.unknown
}

export function mapSavedCardsToPaymentMethods(
  _cards: SavedCardDisplay[],
): AccountSummaryPaymentMethodItem[] {
  return []
}

export function mapSavedCardsToSavedCardItems(
  cards: SavedCardDisplay[],
): AccountSummarySavedCardItem[] {
  return cards.map((card) => ({
    id: card.payment_method_id ?? card.lastFour,
    lastFour: card.lastFour,
    brand: formatCardBrandLabel(card.brand),
    badge: paymentMethodBadgeVariant(card.isDefault),
  }))
}

export function formatProfileCardCountLabel(count: number): string {
  return count === 1 ? '1 card' : `${count} cards`
}

export function formatProfileBankCountLabel(count: number): string {
  return `${count} bank details`
}

export function buildProfilePaymentMethodsSummary(
  cards: SavedCardDisplay[] = [],
  demoPaymentMethods: AccountSummaryPaymentMethodItem[] = [],
): ProfilePaymentMethodsSummary {
  const cardChips = cards.map((card) => ({
    id: card.payment_method_id ?? card.lastFour,
    lastFour: card.lastFour,
    brand: formatCardBrandLabel(card.brand),
  }))

  const bankChips = demoPaymentMethods.map((item) => ({
    id: item.id,
    lastFour: item.lastFour,
    bankName: item.bankName,
  }))

  return {
    cards: cardChips,
    banks: bankChips,
  }
}
